import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogoGenericoComponent } from 'src/app/shared/dialogo-generico/dialogo-generico.component';

@Component({
  selector: 'app-reseteo-mac',
  templateUrl: './reseteo-mac.component.html',
  styleUrls: ['./reseteo-mac.component.css']
})
export class ReseteoMacComponent implements OnInit {

  constructor(public dialogModalGeneric: MatDialog, private router: Router) { }

  ngOnInit() {
  }

  resetearMacForm = new FormGroup({
    nombreUsuario: new FormControl('', [Validators.required]),
    nuevaMac: new FormControl('', [Validators.required]),
  });

  onSubmit(): void {
    if (this.resetearMacForm.invalid) {
      return;
    } else {
      return this.confirm();
    }
  }

  confirm() {
    const dialog = this.dialogModalGeneric.open(DialogoGenericoComponent, {
      width: '25rem',
      disableClose: true,
      data: {
        icon: 'warning',
        message: '¿Está seguro de actualizar la MAC Address al usuario?',
        btCancel: true,
        btAccept: true,
        btClose: false,
        actionBtCancel: 'cancelModal',
        actionBtAccept: 'cancelWithAction',
        actionBtClose: '',
        result: 'info'
      }
    });

    dialog.afterClosed().subscribe(result => {
      if (result === 'action') {
        //alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.asignarPerfilForm.value, null, 4));
        this.navigateMenu('home');
      } else {
        dialog.close(false);
      }
    });
  }

  navigateMenu(tag: string) {
    this.router.navigate(['/' + tag]);
  }

}
